import { useTranslation } from 'react-i18next';

const PriceChangesLegend = ({ collapsed = false }: { collapsed?: boolean }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 text-sm">
      <p className={'whitespace-nowrap'}>
        {t('widget.priceChanges.legend.veryBad')}
      </p>
      <div
        className="bg-red-200 rounded-full bg-gradient-to-r from-purple-dark-3 to-purple relative w-full"
        style={{
          width: collapsed ? '100px' : '370px',
          height: '11px',
        }}
      >
        <div
          className={`
            absolute
            top-0
            right-0
            bottom-0
            left-0
            overflow-hidden
            bg-center
            z-30
            pointer-events-none
            mix-blend-overlay
            rounded-full`}
          style={{ backgroundImage: `url('/overlay-bar.svg')` }}
        />
      </div>
      <p className={'whitespace-nowrap'}>
        {t('widget.priceChanges.legend.veryGood')}
      </p>
    </div>
  );
};

export default PriceChangesLegend;
